import { jsx as e, jsxs as w } from "react/jsx-runtime";
import { useState as i } from "react";
import { useTranslation as C } from "react-i18next";
import { format as n } from "date-fns";
import b from "../../../components/Modal/index.js";
import s from "../../DateInput/index.js";
import p from "../../../icons/Calendar.js";
const f = "forma-ui__modalChoose__dateChooseWrapper", v = "forma-ui__modalChoose__dateLabel", l = {
  dateChooseWrapper: f,
  dateLabel: v
}, L = ({ open: c, onClose: d, onApply: u, onCancel: h }) => {
  const { t } = C(), [a, m] = i(null), [o, y] = i(null), _ = () => {
    u(a && o ? `${n(new Date(a), "dd.MM.yyyy")} - ${n(new Date(o), "dd.MM.yyyy")}` : ""), d();
  };
  return /* @__PURE__ */ e(
    b,
    {
      open: c,
      onClose: d,
      width: "100%",
      maxWidth: "500px",
      title: t("uikit:choose_date"),
      buttons: [
        {
          children: t("uikit:apply"),
          viewStyle: "primary",
          onClick: _,
          disabled: !(a && o)
        },
        {
          children: t("uikit:cancel"),
          viewStyle: "tertiary",
          onClick: h
        }
      ],
      children: /* @__PURE__ */ w("div", { className: l.dateChooseWrapper, children: [
        /* @__PURE__ */ e("input", { type: "hidden", autoFocus: !0 }),
        /* @__PURE__ */ e("div", { children: /* @__PURE__ */ e(
          s,
          {
            name: "date_start",
            value: a,
            onChange: (r) => m(r.target.value),
            placeholder: t("uikit:start_date_placeholder"),
            className: l.dateInput,
            viewStyle: "secondary",
            meta: {
              label: t("uikit:start_date"),
              labelClass: l.dateLabel,
              icon: /* @__PURE__ */ e(p, { width: 16, height: 16 }),
              maxDate: o,
              showIconAlways: !0,
              portalId: "popup-root"
            }
          }
        ) }),
        /* @__PURE__ */ e("div", { children: /* @__PURE__ */ e(
          s,
          {
            name: "date_end",
            value: o,
            onChange: (r) => y(r.target.value),
            placeholder: t("uikit:end_date_placeholder"),
            className: l.dateInput,
            viewStyle: "secondary",
            meta: {
              label: t("uikit:end_date"),
              labelClass: l.dateLabel,
              icon: /* @__PURE__ */ e(p, { width: 16, height: 16 }),
              minDate: a,
              showIconAlways: !0,
              portalId: "popup-root"
            }
          }
        ) })
      ] })
    }
  );
};
export {
  L as default
};
